export enum OrderType {
    BUY     = 'buy',
    SELL    = 'sell',
}
